import type React from 'react';
import { ImageRatio } from '../Shares/ImageRatio';
import { SocialMenu } from './SocialMenu';
export const OfferSection: React.FC = () => {
  return <>
      <ImageRatio ratio={397 / 153} hiddenFrom="sm" src="/assets/offer-mobile.svg" alt="Offer">
        <SocialMenu />
      </ImageRatio>

      <ImageRatio ratio={1320 / 295} visibleFrom="sm" src="/assets/offer.svg" alt="Offer">
        <SocialMenu />
      </ImageRatio>
    </>;
};